import {
  ITutorialDto,
  TutorialJourneyType,
} from "@growth-machine-llc/stridist-api-client";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { FC, useState } from "react";

interface JourneyActivatorDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (journeyType: TutorialJourneyType, description?: string) => void;
  journeys: ITutorialDto[];
  isPending?: boolean;
}

export const JourneyActivatorDialog: FC<JourneyActivatorDialogProps> = ({
  open,
  onClose,
  onSave,
  journeys,
  isPending = false,
}) => {
  const [selected, setSelected] = useState<TutorialJourneyType | "">("");
  const [description, setDescription] = useState<string>("");

  const handleSave = () => {
    if (selected)
      onSave(selected as TutorialJourneyType, description.trim() || undefined);
    handleClose();
  };

  const handleClose = () => {
    setSelected("");
    setDescription("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Create New Journey Activator</DialogTitle>

      <DialogContent>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel id="journey-select-label">Select Journey</InputLabel>
          <Select
            labelId="journey-select-label"
            label="Select Journey"
            value={selected}
            onChange={(e) => setSelected(e.target.value as TutorialJourneyType)}
          >
            {journeys.length ? (
              journeys.map((j) => (
                <MenuItem key={j.id} value={j.type}>
                  {j.title} ({j.type})
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No journeys available</MenuItem>
            )}
          </Select>
        </FormControl>

        <TextField
          margin="dense"
          label="Description (optional)"
          fullWidth
          multiline
          minRows={2}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          sx={{ mt: 2 }}
        />
      </DialogContent>

      <DialogActions sx={{ p: 2, justifyContent: "center" }}>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={selected === "" || isPending}
        >
          Create Activator
        </Button>
      </DialogActions>
    </Dialog>
  );
};
